import { team } from '@/types/team';
import { rule } from '@/types/rule';
import { shareExtendInfo } from '@/types/shareExtendInfo';

interface response {
  code: number;
  message: string;
  data: {
    /**
     * 期数：本期3.21~3.28，后端拼接
     */
    period: string;
    /**
     * 上期领奖状态
     */
    previousPeriodObtainFlag: boolean;
    /**
     * 上期领奖数量
     */
    previousPeriodObtainCount: number;
    /**
     * 头图， 已组队
     */
    bannerForTeam: string;
    /**
     * 头图， 未组队	
     */
    bannerForNoTeam: string;
    /**
     * 我的队伍信息
     */
    team: team;
    /**
     * 组队玩法规则
     */
    rule: rule;
    /**
     * 受邀者进入活动页面额外信息	
     */
    shareExtendInfo: shareExtendInfo;
    host: string;
  };
}

export function mainPage (shareCode?: string): Promise<response> {
  if (shareCode) {
    return request({
      url: '/gamecard/v2/share/assistance/mainPage',
      data: {
        shareCode
      },
    });
  } else {
    return request({
      url: '/gamecard/v2/share/assistance/mainPage'
    });
  }

}
